export const SupportedTextCharset = ['utf-8', 'shift_jis'] as const
export type CSVCharset = (typeof SupportedTextCharset)[number]
